<template>
    <!-- Loading -->
    <div class="vld-parent">
        <loading
            v-model:active="isLoading"
            :is-full-page="true"
            :height="128"
            :width="128"
        />
    </div>

    <!-- Modal close -->
    <div
        class="w-full h-screen bg-transparent absolute top-0 left-0 right-0 z-40 cursor-default"
        v-show="EmployeeContractFileModal || detailModal || deleteModal"
        @click="
            (EmployeeContractFileModal = false),
            (detailModal = false),
            (deleteModal = false)
        "
    ></div>

    <!-- Form Modal -->
    <vue-final-modal
        v-model="EmployeeContractFileModal"
        classes="base-modal"
        :ssr="true"
        :content-class="
            darkMode
                ? 'add-modal bg-darkmode-base transition-colors duration-1000'
                : 'add-modal bg-gray-100 transition-colors duration-1000'
        "
        :lock-scroll="true"
        :hide-overlay="false"
        :click-to-close="true"
        :esc-to-close="true"
        :prevent-click="true"
        :attach="false"
        transition="vfm"
        overlay-transition="vfm"
        :z-index-auto="true"
        :z-index-base="1000"
        :z-index="false"
        :focus-retain="true"
        :focus-trap="false"
        :fit-parent="true"
        :drag="false"
        drag-selector=""
        :keep-changed-style="false"
        :resize="false"
        :resize-directions="['t','tr','r','br','b','bl','l','tl']"
        :min-width="250"
        :min-height="250"
        :max-width="Infinity"
        :max-height="Infinity"
    >
        <div class="modal-head">
            <h1 v-if="showEdit">{{ $t("employeecontractfile.editform") }}</h1>
            <h1 v-else>{{ $t("employeecontractfile.addform") }}</h1>

            <jb-button
                class="btn-close-modal"
                :icon="mdiClose"
                @click="EmployeeContractFileModal = false"
            />
        </div>

        <div class="modal-content">
            <EmployeeContractFileForm
                :show-edit="showEdit"
                :prop-employee-contract-file="EmployeeContractFileObject"
                :employee-contract-id="employeeContractId"
                :employee-id="employeeId"
                @close-modal="hideModal"
                @refresh-list="refresh"
                @reset-modal="resetModal"
            />
        </div>
    </vue-final-modal>

    <!-- Detail Modal -->
    <vue-final-modal
        v-model="detailModal"
        classes="base-modal"
        :ssr="true"
        content-class="add-modal bg-gray-100 dark:bg-gray-700 transition-colors duration-1000 w-11/12 md:w-2/3 lg:w-1/2 h-5/6"
        :lock-scroll="true"
        :hide-overlay="false"
        :click-to-close="true"
        :esc-to-close="true"
        :prevent-click="true"
        :attach="false"
        transition="vfm"
        overlay-transition="vfm"
        :z-index-auto="true"
        :z-index-base="1000"
        :z-index="false"
        :focus-retain="true"
        :focus-trap="false"
        :fit-parent="true"
        :drag="false"
        drag-selector=""
        :keep-changed-style="false"
        :resize="false"
        :resize-directions="['t','tr','r','br','b','bl','l','tl']"
        :min-width="250"
        :min-height="250"
        :max-width="Infinity"
        :max-height="Infinity"
    >
        <div class="modal-head">
            <h1>{{ $t("employeecontractfile.detail") }}</h1>
            <jb-button
                class="btn-close-modal"
                :icon="mdiClose"
                @click="detailModal = false"
            />
        </div>

        <div class="modal-content detail-content">
            <EmployeeContractFileDetail
                :prop-employee-contract-file="EmployeeContractFileObject"
                @close-modal="detailModal = false"
                @refresh-list="refresh"
            />
        </div>
    </vue-final-modal>

    <!-- Delete Modal -->
    <vue-final-modal
        v-model="deleteModal"
        classes="base-modal"
        :ssr="true"
        :content-class="
        darkMode
            ? 'delete-modal bg-darkmode-base transition-colors duration-1000'
            : 'delete-modal bg-gray-100 transition-colors duration-1000'
        "
        :lock-scroll="true"
        :hide-overlay="false"
        :click-to-close="true"
        :esc-to-close="true"
        :prevent-click="true"
        :attach="false"
        transition="vfm"
        overlay-transition="vfm"
        :z-index-auto="true"
        :z-index-base="1000"
        :z-index="false"
        :focus-retain="true"
        :focus-trap="false"
        :fit-parent="true"
        :drag="false"
        drag-selector=""
        :keep-changed-style="false"
        :resize="false"
        :resize-directions="['t', 'tr', 'r', 'br', 'b', 'bl', 'l', 'tl']"
        :min-width="250"
        :min-height="250"
        :max-width="Infinity"
        :max-height="Infinity"
    >
        <!-- Modal header -->
        <div class="modal-head">
        <h1>{{ $t("menu.delete") }} {{ $t("menu.data") }}</h1>

        <jb-button
            class="btn-close-modal"
            :icon="mdiClose"
            @click="deleteModal = false"
        />
        </div>

        <!-- Modal content -->
        <div class="delete-content">
            <div class="warning">{{ $t("menu.warning") }}</div>

            <div class="messsage">
                <p>{{ $t("confirmDelete.message") }}</p>
            </div>
        </div>

        <!-- Button action -->
        <div
            class="buttons-submit transition-colors duration-1000"
            :class="darkMode ? 'bg-darkmode-base' : 'bg-gray-100'"
        >
        <jb-buttons class="buttons-action-submit">
            <jb-button
                :label="$t('finance.button.btnConfirm')"
                color="info"
                :icon="mdiTrashCan"
                @click="confirm"
                class="form-submit-btn"
            />
            <jb-button
                :label="$t('finance.button.btnCancel')"
                outline
                @click="cancel"
                class="btn-reset form-noicon-btn"
            />
        </jb-buttons>
        </div>
    </vue-final-modal>

    <!-- view file modal -->
    <vue-final-modal
        v-model="viewFileModal"
        classes="base-modal"
        :ssr="true"
        content-class="medium-modal bg-gray-100 dark:bg-gray-700 transition-colors duration-1000"
        :lock-scroll="true"
        :hide-overlay="false"
        :click-to-close="true"
        :esc-to-close="true"
        :prevent-click="true"
        :attach="false"
        transition="vfm"
        overlay-transition="vfm"
        :z-index-auto="true"
        :z-index-base="1000"
        :z-index="false"
        :focus-retain="true"
        :focus-trap="false"
        :fit-parent="true"
        :drag="false"
        drag-selector=""
        :keep-changed-style="false"
        :resize="false"
        :resize-directions="['t', 'tr', 'r', 'br', 'b', 'bl', 'l', 'tl']"
        :min-width="250"
        :min-height="250"
        :max-width="Infinity"
        :max-height="Infinity"
    >
        <!-- Modal header -->
        <div class="modal-head">
        <h1>Show file</h1>

        <jb-button
            class="btn-close-modal"
            :icon="mdiClose"
            @click="viewFileModal = false"
        />
        </div>

        <!-- Modal Content -->
        <div class="modal-content detail-content">
            <img
                :src="fileData.file"
                alt="Preview image"
                v-if="['png', 'jpg', 'jpeg'].includes(fileData.type)"
                style="width: 100%"
            />

            <!-- Show PDF using vue-pdf-embed -->
            <vue-pdf-embed
                v-else-if="fileData.type === 'pdf'"
                :source="fileData.file"
                style="width: 100% !important; height: 100% !important"
            />

            <!-- Fallback message -->
            <span class="text-4xl" v-else>File Not Found</span>
        </div>
    </vue-final-modal>

    <!-- Main section -->
    <main-section class="overflow-x-hidden">
        <jb-button
            label="Add"
            color="info"
            :icon="mdiPlusCircleOutline"
            small
            @click="addEmployeeContractFile"
            class="ml-4 w-auto px-8 py-2 md:hidden"
        />

        <card-component
            class="relative mt-2 px-2 md:px-4 bg-white border border-gray-100 dark:bg-gray-900 dark:border-gray-600"
            :title="$t('employeecontractfile.title')"
            :icon="mdiCalendar"
            has-table
        >
            <jb-button
                label="Add"
                color="info"
                :icon="mdiPlusCircleOutline"
                small
                @click="addEmployeeContractFile"
                class="py-1 px-5 shadow-lg mt-1 w-auto absolute right-4 top-1 hidden md:flex"
            />

            <ag-grid-vue
                ref="agGridTraining"
                style="width: 100%; height: 70vh"
                class="ag-theme-alpine"
                :defaultColDef="defaultColDef"
                :columnDefs="columnDefs"
                :pagination="true"
                :context="context"
                :rowData="rowData"
                :rowSelection="rowSelection"
                @grid-ready="onGridReady"
                @first-data-rendered="handleFirstDataRendered"
            />
        </card-component>
    </main-section>
</template>

<script>
/* eslint-disable */
import axios from 'axios'
import { onMounted, ref, reactive, onUpdated, computed, watch, watchEffect } from 'vue'
import { useStore } from 'vuex'
import { mdiCalendar, mdiCircleEditOutline, mdiTrashCan, mdiPlusCircleOutline, mdiClose } from '@mdi/js'
import MainSection from '@/components/MainSection'
import HeroBar from '@/components/HeroBar'
import TitleBar from '@/components/TitleBar'
import ModalBox from '@/components/ModalBox'
import JbButtons from '@/components/JbButtons'
import Divider from '@/components/Divider'
import JbButton from '@/components/JbButton'
import CardComponent from '@/components/CardComponent'
import { useToast } from 'vue-toastification'
import EmployeeContractFileForm from "@/views/humanresource/employeeContractFile/EmployeeContractFileForm"
import EmployeeContractFileDetail from "@/views/humanresource/employeeContractFile/EmployeeContractFileDetail"
import Field from '@/components/Field'
import Control from '@/components/Control'
import { AgGridVue } from 'ag-grid-vue3'
import { useI18n } from 'vue-i18n'
import ButtonActionRender from '@/components/ButtonActionRender'
import ButtonActive from '@/components/ButtonActive'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import VuePdfEmbed from "vue-pdf-embed";


export default {
  components: {
    MainSection,
    Loading,
    TitleBar,
    CardComponent,
    HeroBar,
    EmployeeContractFileForm,
    EmployeeContractFileDetail,
    ModalBox,
    JbButton,
    JbButtons,
    Divider,
    AgGridVue,
    Control,
    Field,
    ButtonActive,
    ButtonActionRender,
    VuePdfEmbed,
  },
  props: {
    propEmployeeContract: {
      type: Object,
      default: null
    },
    employeeContractId: {
      type: String,
      default: ''
    },
    employeeId: {
      type: String,
      default: ''
    }
  },
  setup(props) {
    // state validation
    const { t } = useI18n()
    const isLoading = ref(false)
    // const rowData = reactive([])
    const rowData = ref([])
    const filter = reactive({
      id: '',
      employee_id: '',
      employee_contract_id: '',
      name: '',
      file: '',
    })
    const isAsideMobileExpanded = computed(() => store.state.isAsideMobileExpanded)
    const store = useStore()
    const toast = useToast()
    const EmployeeContractFileModal = ref(false)
    const detailModal = ref(false)
    const deleteModal = ref(false)
    const viewFileModal = ref(false);
    const employeeId = ref(props.employeeId)
    const employeeContractId = ref(props.employeeContractId)
    const EmployeeContractFileObject = ref({})
    const showEdit = ref(false)
    const confirm = () => confirmDelete()
    const cancel = () => deleteModal.value = false

    const columnDefs = [
      { headerName: "#", valueGetter: "node.rowIndex + 1", minWidth: 50 },
      { field: "name", headerName: t("employeecontractfile.name"), sortable: true, filter: true, minWidth: 150 },
      { field: "file", headerName: t("employeecontractfile.file-name"), sortable: true, filter: true, minWidth: 150 },
      { field: 'id', headerName: t('main.action'), sortable: true, filter: true, minWidth: 165, cellRenderer: 'ButtonActionRender' }
    ]

    const defaultColDef = {
      resizable: true
    }

    const refresh = async () => {
      isLoading.value = true
      // const url = props.employeeContractId ? `employeecontract-file?employee_contract_id=${props.employeeContractId}` : 'employeecontract-file'
      const url = `employeecontract-file?employee_id=${props.employeeId}&employee_contract_id=${props.employeeContractId}`

      await axios
        .get(url)
        .then(response => {
          rowData.value = response.data.data
          isLoading.value = false
        })
        .catch(error => {
          toast.error(error.response?.data?.message || 'Failed to load data', { timeout: 5000 })
          console.log(error)
          isLoading.value = false
        })
    }

    watch(() => props.employeeContractId, () => {
      refresh()
    })

    onMounted(() => {
      refresh()
    })

    const hideModal = () => {
      EmployeeContractFileModal.value = false
      detailModal.value = false
      refresh()
    }

    const showModal = () => {
      EmployeeContractFileModal.value = !EmployeeContractFileModal.value
    }

    const resetModal = () => {
      Object.assign(filter, {
        id: "",
        employee_id: "",
        employee_contract_id: "",
        name: "",
        file: "",
      })
    }

    const addEmployeeContractFile = () => {
      showModal()
      resetModal()
      showEdit.value = false
      EmployeeContractFileObject.value = filter
      employeeContractId.value = props.employeeContractId
    }

    const detailData = (event, data) => {
      EmployeeContractFileObject.value = data
      detailModal.value = true
    }

    const editData = (event, data) => {
      showModal()
      EmployeeContractFileObject.value = { ...data }
      employeeContractId.value = props.employeeContractId
      showEdit.value = true
    }

    const deleteModalShow = (value) => {
      deleteModal.value = true
      deleteModal.id = value
    }

    const confirmDelete = () => {
      axios
        .delete(`employeecontract-file/${deleteModal.id}`)
        .then(response => {
            if (response.data.success) {
              refresh()
              toast.success(response.data.message, { timeout: 5000 })
            } else {
              toast.error(response.data.message, { timeout: 5000 })
            }
            deleteModal.value = false
        })
        .catch(error => {
          toast.error(error.response?.data?.message || 'Failed to delete', { timeout: 5000 })
          console.log(error)
          deleteModal.value = false
        })
    }

    const fileData = ref({
      file: "",
      type: "",
    })

    const getFile = async () => {
      isLoading.value = true
      await axios
        .get("show-file-employeecontract/" + viewFileModal.id)
        .then((response) => {
        if (response.data.success) {
          fileData.value = response.data.data
        } else {
          fileData.value = []
        }
        isLoading.value = false
        })
        .catch((error) => {
          isLoading.value = false
          console.log(error)
        })
    }

    const viewFile = (event, id) => {
      viewFileModal.value = true
      viewFileModal.id = id
      getFile()
    }

    return {
      isLoading,
      EmployeeContractFileObject,
      showEdit,
      EmployeeContractFileModal,
      addEmployeeContractFile,
      hideModal,
      showModal,
      detailModal,
      detailData,
      editData,
      mdiCalendar,
      mdiClose,
      mdiCircleEditOutline,
      mdiTrashCan,
      mdiPlusCircleOutline,
      toast,
      refresh,
      rowData,
      filter,
      columnDefs,
      defaultColDef,
      t,
      gridApi: null,
      gridColumnApi: null,
      ButtonActionRender,
      deleteModal,
      deleteModalShow,
      confirm,
      cancel,
      confirmDelete,
      resetModal,
      isAsideMobileExpanded,
      viewFileModal,
      viewFile,
      fileData,
    }
  },
  beforeMount() {
    this.context = {componentParent: this}
  },
  methods: {
    onGridReady(params) {
      this.gridApi = params.api
      this.gridColumnApi = params.columnApi
      const allColumnIds = []
      this.gridColumnApi.getAllColumns().forEach((column) => {
          allColumnIds.push(column.colId)
      })
      this.gridColumnApi.autoSizeColumns(allColumnIds, false)
    }
  }
}
</script>